import React from "react";
import { useEffect, useState } from "react";
import {
    Container,
    Grid,
    Loader,
    Text,
    Image,
    Stack,
    Title,
    Divider,
    Center,
    AspectRatio,
    Box,
    Spoiler,
    Flex,
    SimpleGrid,
} from "@mantine/core";
import { useParams } from "react-router-dom";
import GoogleMap from "../../Components/map_react";
import { Animate } from "react-simple-animate";
import { useViewportSize } from "@mantine/hooks";
import parse from "html-react-parser";

function getStops(tour, day) {
    var stops = [];
    var odd = true;
    stops.push(
        tour.tour_days[parseInt(day) - 1].stops.map((stop, index) => {
            let stop_string = " - ";
            stop.stop_types.map((type, index) => {
                stop_string += type.icon + " ";
            });
            // console.log(stop_string);
            odd = !odd;
            return (
                <Box key={stop._joinData.id}>
                    <Grid
                        w={"90%"}
                        bg={odd ? "grey.0" : "grey.1"}
                        key={stop._joinData.id}
                    >
                        <Grid.Col span={{ base: 12, md: 8 }}>
                            <Container fluid p={0}>
                                <Title>
                                    {stop.name}
                                    {stop_string != " - " && (
                                        <span style={{ fontFamily: "BST" }}>
                                            {stop_string}
                                        </span>
                                    )}
                                </Title>
                                <Spoiler
                                    maxHeight={70}
                                    showLabel="Read more"
                                    hideLabel="Hide"
                                >
                                    <Text>{parse(stop.description)}</Text>
                                </Spoiler>
                            </Container>
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, md: 4 }} p={0}>
                            <Container fluid p={0}>
                                <AspectRatio ratio={16 / 9} mx="auto">
                                    <Image
                                        src={`https://www.best-scottish-tours.co.uk/Plugin/Stops/assets/image/${stop.image}`}
                                    />
                                </AspectRatio>
                            </Container>
                        </Grid.Col>
                    </Grid>
                    <Divider size={6} color="gray.0" />
                </Box>
            );
        }),
    );
    return stops;
}

export default function Day(props) {
    const [stops, setStops] = useState(null);
    const [tour, setTour] = useState(props.tour.tour);
    const [day, setDay] = useState(props.day);
    const { height, width } = useViewportSize();

    let params = useParams();
    // if (day != parseInt(params.id)) {
    //     setDay(parseInt(params.id));
    // }
    useEffect(() => {
        // console.log(tour);

        if (tour == null) {
            fetch("/tours/get/138")
                .then((res) => res.json())
                .then(
                    (result) => {
                        setTour(result);
                        // console.log(result);
                        setStops(getStops(tour, day));
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {},
                );
        } else {
            setStops(getStops(tour, day));
        }
    }, [day]);
    return (
        <Grid h={height - 163} p={0} pt={25}>
            <Grid.Col
                span={{ base: 12, md: 8 }}
                style={{ overflowY: "scroll" }}
            >
                <Animate
                    play={true}
                    start={{
                        transform: "translateX(-100px)",
                        opacity: 0.1,
                    }}
                    end={{ transform: "translateX(0px)", opacity: 1 }}
                    easeType="ease-in"
                    duration={0.3}
                    delay={0}
                >
                    <Box>{stops}</Box>
                </Animate>
            </Grid.Col>
            <Grid.Col p={0} h={height - 163} span={{ base: 12, md: 4 }}>
                <Stack gap={0} h={"100%"}>
                    <Center h={"20%"}>
                        <Divider
                            h={"100%"}
                            color="purple.0"
                            orientation="vertical"
                            size="sm"
                        />
                    </Center>
                    <Flex justify="flex-center" direction="column" h={"10%"}>
                        <Container>
                            <Title fz={50}>Day {parseInt(day)}</Title>
                        </Container>
                    </Flex>
                    <Center h={"20%"}>
                        {tour.tour_days.length != day && (
                            <Divider
                                h={"100%"}
                                color="purple.0"
                                orientation="vertical"
                                size="sm"
                            />
                        )}
                    </Center>
                    <Container h={"50%"} w={"100%"}>
                        <GoogleMap
                            tour={[tour.tour_days[parseInt(day) - 1]]}
                        ></GoogleMap>
                    </Container>
                </Stack>
            </Grid.Col>
        </Grid>
    );
}
